module.exports = __webpack_public_path__ + "components/weather-icon/static/daysomeclear-e28322c86e566494538a54a769c30206.svg";